import { themeAlpine } from 'ag-grid-community';
import { createGlobalStyle, useTheme } from 'styled-components';

export const GlobalTableTheme = createGlobalStyle`
  [class*=ag-theme-] {
    --ag-border-color: ${({ theme }) => theme.colors.neutral[100]};
    --ag-border-width: 1px;
    --ag-border-style: solid;
    --ag-selected-row-background-color: ${({ theme }) => theme.colors.purple[100]};
    --ag-cell-horizontal-border: 1px solid var(--ag-border-color);
    --ag-cell-horizontal-padding: 0px;
    --ag-control-panel-background-color: ${({ theme }) => theme.colors.neutral[0]};
    --ag-popup-shadow: 0px 4px 16px 0px rgba(27,36,50,0.10),0px 1px 8px 0px rgba(27,36,50,0.10);
    --ag-foreground-color: ${({ theme }) => theme.colors.text.main};
    --ag-row-border-color: ${({ theme }) => theme.colors.neutral[0]};

    --ag-range-selection-background-color: ${({ theme }) => theme.colors.purple[100]};
    --ag-range-selection-border-color: ${({ theme }) => theme.colors.purple[300]};
    --ag-range-selection-border-style: solid;
    --ag-range-selection-border-width: 1px;

    .ag-root-wrapper {
      border-left: none;
      border-right: none;

      // disable group expand/collapse icons
    .ag-group-expanded,
      .ag-group-contracted {
        display: none;
      }
    }

    /* .ag-pinned-left-header, */
    .ag-header-cell-checkbox,
    .ag-column-checkbox {
      border: none;
      background-color: transparent !important;
    }

    .ag-column-checkbox {
      border-bottom: 1px solid var(--ag-border-color);
      & .ag-cell:focus {
        outline: none;
        background-color: transparent;
      }
    }

    // add border to all cells except first column
    .ag-cell:not(.ag-cell-range-selected):not(.ag-cell-focus)${({ canSelect }) =>
      canSelect ? ':not(.ag-column-first)' : ''} {
      border-bottom: 1px solid var(--ag-border-color);
    }

    // remove border from loader cell
    .span-load-more-cell {
      .ag-cell:not(.ag-column-first):not(.ag-cell-range-selected) {
        border-right: none;
      }
    }

    .ag-pinned-right-cols-container {
      .span-load-more-cell, .ag-row {
        .ag-cell:not(.ag-column-first):not(.ag-cell-range-selected):last-child {
          border-right: 1px solid var(--ag-border-color);
        }
      }
    }

    .ag-row-group-expanded,
    .ag-row-group-contracted {
      .ag-cell:not(.ag-cell-range-selected) {
        border-right: none;
      }

      .ag-cell.ag-column-first:not(.ag-cell-range-selected) {
        border-bottom: 1px solid var(--ag-border-color);
      }
    }

    .last-row {
      .ag-cell:not(.ag-cell-range-selected) {
        border-bottom: 1px solid var(--ag-border-color);
      }
    }

    .ag-row-hover {
      background-color: ${({ theme }) => theme.colors.neutral[20]};
    }

    .ag-row-first {
      border-top: none;
    }

    .ag-header-cell {
      border-right: 1px solid var(--ag-border-color);
    }

    .ag-pinned-right-header {
      .ag-column-last .ag-header-cell-comp-wrapper {
        border-right: 1px solid var(--ag-border-color);
      }
    }

    .ag-group-value {
      width: 100%;
    }
    .ag-header-cell.ag-column-first {
      border-right: none;
    }

    .ag-column-first {
      border-left: ${({ enableLeftTableBorder }) =>
        enableLeftTableBorder ? '1px solid var(--ag-border-color)' : 'none'};
    }

    .no-contacts {
      .ag-cell-no-contacts:not(.ag-cell-range-selected):not(.ag-column-last) {
        border-right: none !important;
      }
    }

    scrollbar-width: thin;
    scrollbar-color: #dee3ed transparent;

    .ag-header-cell-checkbox  {
      width: 40px !important;
      .ag-header-cell-comp-wrapper > div {
        width: 100%;
        padding: 0;
        justify-content: flex-start;
        padding-left: 16px;
      }
    }

    /* .ag-header-cell-comp-wrapper, */
    .ag-column-checkbox {
      max-width: 40px !important;
      padding-left: 16px !important;
    }
  }

  .ag-row {
      border-bottom: none !important;
  }

  .ag-rich-select-virtual-list-viewport {
    .ag-rich-select-row-selected {
      background-color: ${({ theme }) => theme.colors.neutral[20]};
      font-weight: 500;
      position: relative;
      &::before {
        content: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDE0IDEwIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMTIuMzMzMyAxTDQuOTk5OTkgOC4zMzMzM0wxLjY2NjY2IDUiIHN0cm9rZT0iIzhBNzVGMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=");
        position: absolute;
        right: 16px;
        top: 4px;
        width: 16px;
        height: 16px;
      }

      .ag-react-container {
        width: 100%;
      }

      .ag-rich-select-row-custom-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 32px;
      }
    }
  }
  .ag-rich-select-value {
    .ag-icon-small-down {
      &::before {
        content: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgMTAgNiIgZmlsbD0ibm9uZSI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjODc5N0FCIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==");
        mask-image: none;
        background: transparent;
        position: relative;
        top: -2px;
      }
    }
  }

  .ai-campaign-row {
    background-color: ${({ theme }) => theme.colors.pink[20]};
    &.ag-row-hover:before {
      background-color:${({ theme }) => theme.colors.purple[100]};
    }
  }

  .ag-pinned-left-cols-container .ai-campaign-row {
    box-shadow: 4px 0 0 0 ${({ theme }) => theme.colors.pink[400]} inset;
    &.ag-row-hover:before {
      box-shadow: 4px 0 0 0 ${({ theme }) => theme.colors.pink[400]} inset;
    }
  }
`;

export const useTableTheme = () => {
  const fontFamily = ['Silka', 'Helvetica', 'Arial', 'sans-serif'];
  const theme = useTheme();
  const tableTheme = themeAlpine.withParams({
    accentColor: '#4900FF',
    browserColorScheme: 'light',
    cellTextColor: theme.colors.text.main,
    headerBackgroundColor: theme.colors.neutral[0],
    headerFontFamily: fontFamily,
    fontFamily,
    cellFontFamily: fontFamily,
    headerFontSize: 12,
    headerFontWeight: 400,
    headerTextColor: theme.colors.text.subtle,
    borderColor: theme.colors.neutral[100],
    cellHorizontalPadding: 16,
    cellVerticalPadding: 16,
    wrapperBorder: false,
    headerRowBorder: true,
    columnBorder: true,
    rowBorder: {
      width: 1,
      color: theme.colors.neutral[100],
      style: 'solid',
    },
    menuBackgroundColor: theme.colors.purple[0],
    rowHoverColor: theme.colors.neutral[20],
  });

  return tableTheme;
};
